import { useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router"

let nowFetched: string | null = null

const useSubjectData = () => {
  const params = useParams()
  const pathname = useLocation().pathname
  const pathSplit = pathname.split('/').slice(1)
  const pick = params.subject
  const [lastPick, setLastPick] = useState<string | null>(null)
  const navigate = useNavigate()
  const [currentConfig, setCurrentConfig] = useState<Record<string, string> | null>(null)

  useEffect(() => {
    if (!pick) return
    setLastPick(pick)
  }, [pick])

  const currentConfigFile = useMemo(() => pathSplit.slice(0, 2).length === 2 && `/assets/${pathSplit.slice(0, 2).join('/')}/index.json`, [pathSplit])

  useEffect(() => {
    if (!currentConfigFile) {
      //setCurrentConfig(null)
      return
    }
    if (nowFetched === currentConfigFile && currentConfig) return
    fetch(currentConfigFile)
      .then((res) =>
        res.json().then((res) => {
          if (Object.keys(res).length === 1 && !pick) {
            navigate('./' + Object.keys(res)[0], { relative: 'path' })
          }
          nowFetched = currentConfigFile
          setCurrentConfig(res)
        })
      )
      .catch((err) => setCurrentConfig(null))
  }, [currentConfigFile, pick, currentConfig])

  return {
    subjects: currentConfig,
    subject: pick,
    lastSubject: lastPick,
  }
}

export default useSubjectData